import { FilterInputs, InputItem, ListInputItemOptions } from '../model';

export const mapDataToInputItems = (
  data: any,
  idKey: string,
  valueKey: string,
  selected?: string,
  eitherOr?: boolean
) => {
  return data?.map((x: any) => ({
    id: x?.[idKey] || '',
    value: x?.[valueKey] || '',
    selected: selected ? x?.[selected] || false : false,
    ...(eitherOr ? { eitherOr } : {}),
  }));
};

export const mapDataToInputItemsFromAppliedFilter = (
  appliedFilters: FilterInputs,
  data: any,
  idKey: string,
  valueKey: string,
  filterKey: string
): InputItem[] => {
  const key = filterKey as ListInputItemOptions;
  const filterInputs = appliedFilters?.listInputItem?.[key] || [];
  const selectedItems = filterInputs
    .filter((x) => x.selected)
    ?.map((x) => x.id);
  return data?.map((x: any) => ({
    id: x?.[idKey] || '',
    value: x?.[valueKey] || '',
    selected: selectedItems.includes(x?.[idKey] || ''),
  }));
};

export const mapStringDataToInputItemsFromAppliedFilter = (
  appliedFilters: FilterInputs,
  data: string[],
  filterKey: string
): InputItem[] => {
  const key = filterKey as ListInputItemOptions;
  const filterInputs = appliedFilters?.listInputItem?.[key] || [];
  const selectedItems = filterInputs
    .filter((x) => x.selected)
    ?.map((x) => x.id);
  return data?.map((x: any) => ({
    id: x || '',
    value: x || '',
    selected: selectedItems.includes(x || ''),
  }));
};
